import { ReactElement, useCallback } from 'react';
import {
  AuthenticationError,
  AxiosResult,
  AxiosResultDefaultError,
} from '../../../../../api/request';
import { createFetchContext } from '../../../../../components/contexts/FetchContextFactory';
import { SpecialtyAreasResponse } from '../../type';
import { PaginationQuery } from '../../../../../types/pagination';
import DisplayError from '../../../../../components/info/DisplayError';
import { getSpecialtyAreasList } from '../../api';

interface BaseLoaderProps {
  children: ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  PaginationQuery,
  SpecialtyAreasResponse,
  AuthenticationError | AxiosResultDefaultError
>();

export function useSpecialtyAreasLoader() {
  return useFetch();
}

export const SpecialtyAreasLoaderConsumer = FetchConsumer;

export default function SpecialtyAreasLoader({ children }: BaseLoaderProps) {
  const request = useCallback(
    async (
      query: PaginationQuery,
    ): Promise<
      AxiosResult<SpecialtyAreasResponse, AxiosResultDefaultError>
    > => {
      return getSpecialtyAreasList(query);
    },
    [],
  );

  return (
    <FetchProvider
      request={request}
      defaultQuery={{
        page: 1,
        itemsPerPage: 10,
      }}
      fetchImmediately
    >
      <SpecialtyAreasLoaderConsumer>
        {({ error, refresh }) => {
          if (error) {
            return (
              <DisplayError
                typeError={(error as any)?.code}
                retryAction={refresh}
              />
            );
          }
          return children;
        }}
      </SpecialtyAreasLoaderConsumer>
    </FetchProvider>
  );
}
